import { Form, Formik } from "formik";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { Col, Row } from "reactstrap";
import * as Yup from "yup";
import { RavenAgTable } from "../../components/Common/CombinedComponents";
import RavenQueryBuilder from "../../components/Common/QueryBuilder/RavenQueryBuilder";
import RavenQueryViewer from "../../components/Common/QueryBuilder/RavenQueryViewer";

const initializeQuery = '{"rules":[{"field":"CustomerTypeGuid","operator":"in","value":"[\'2\']"},{"field":"CustomerGroupGuid","operator":"in","value":"[\'221201090924000170\',\'221129135638000143\']"}]}';
const cardEmbossFeeGroup = 7;
class RavenQueryBuilderEx extends Component {
  constructor(props) {
    super(props);
    //
    this.state = {
      record: "",
      ravenQuery: "",
      recordList: [ {query: initializeQuery } ],
      intializeQuery: initializeQuery
    };

  }

  //#region Base Operations

  //#endregion

  handleSubmit = e => {};

  setRavenQuery = (querySnap) => {
    this.setState({ ravenQuery: querySnap });
  };

  render() {
    const recordList = this.state.recordList;
    
    const DropDownOperations = [
    ];
    const recordcolumns = [
      {
        headerName: this.props.t("Query"),
        field: "query",
        tooltipField: "query",
        cellRenderer: RavenQueryViewer,
        cellRendererParams: (params) => {
          return {
          initializeQuery: params.value,
          profileGroupGuid: cardEmbossFeeGroup
          };
        },
        autoHeight: true,
      }
    ];

    return (
      <React.Fragment>
        <div className="page-content">
          <Formik
            enableReinitialize={true}
            initialValues={{}}
            validationSchema={Yup.object().shape({})}
            onSubmit={values => {
              this.handleSubmit(values);
            }}
          >
            {({ errors, status, touched }) => (
              <Form>
                <Row>
                  <Col lg={12}>
                    <div className="mb-3">
                      <RavenQueryBuilder
                        onQueryChangeSet={(e) => this.setRavenQuery(e)}
                        profileGroupGuid={cardEmbossFeeGroup}
                        disabled={this.state.isDetail}
                      />
                    </div>
                    <div className="mb-3">
                      <RavenQueryViewer profileGroupGuid={cardEmbossFeeGroup} initializeQuery={initializeQuery} />
                    </div>
            
                    <div className="mb-3">
                    <RavenAgTable
                      onAddClick={ () => {return null;}}
                      onEditClick={ () => {return null;}}
                      onDetailClick={ () => {return null;}}
                      onDeleteClick={ () => {return null;}}
                      DropdownItems={DropDownOperations}
                      actionItems={true}
                      screenName={"Query Viewer"}
                      SearchContent={SearchContent}
                      exportOption={true}
                      recordcolumns={recordcolumns}
                      recordList={recordList}
                    />
                    </div>
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        </div>
      </React.Fragment>
    );
  }
}

RavenQueryBuilderEx.propTypes = {
    intializeQuery: PropTypes.any,
    error: PropTypes.any,
    t: PropTypes.any,
  };
  
  
  export default connect()(withTranslation()(RavenQueryBuilderEx));
